/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Search_Result_CountInputs */

const en_directory_search_result_count = /** @type {(inputs: Directory_Search_Result_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} published products`)
};

const zh_directory_search_result_count = /** @type {(inputs: Directory_Search_Result_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个已发布产品`)
};

/**
* | output |
* | --- |
* | "{count} published products" |
*
* @param {Directory_Search_Result_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_result_count = /** @type {((inputs: Directory_Search_Result_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Result_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_result_count(inputs)
	return zh_directory_search_result_count(inputs)
});
export { directory_search_result_count as "directory.search.result_count" }